import { lazy } from 'react';
import { CalculatorCategory } from './calculatorUtils';

// Professional Tools
const AIDetectorCalculator = lazy(() => import('../components/calculators/professional/AIDetectorCalculator'));
const HoursCalculator = lazy(() => import('../components/calculators/professional/HoursCalculator'));
const ProductivityCalculator = lazy(() => import('../components/calculators/professional/ProductivityCalculator'));
const BusinessLoanCalculator = lazy(() => import('../components/calculators/professional/BusinessLoanCalculator'));
const SBALoanCalculator = lazy(() => import('../components/calculators/professional/SBALoanCalculator'));
const EquipmentLoanCalculator = lazy(() => import('../components/calculators/professional/EquipmentLoanCalculator'));
const PaintCalculator = lazy(() => import('../components/calculators/professional/PaintCalculator'));
const TileCalculator = lazy(() => import('../components/calculators/professional/TileCalculator'));
const ROICalculator = lazy(() => import('../components/calculators/professional/ROICalculator'));
const BreakEvenCalculator = lazy(() => import('../components/calculators/professional/BreakEvenCalculator'));
const FreelanceRateCalculator = lazy(() => import('../components/calculators/professional/FreelanceRateCalculator'));
const EmployeeCostCalculator = lazy(() => import('../components/calculators/professional/EmployeeCostCalculator'));
const ConversionRateCalculator = lazy(() => import('../components/calculators/professional/ConversionRateCalculator'));
const CustomerLifetimeValueCalculator = lazy(() => import('../components/calculators/professional/CustomerLifetimeValueCalculator'));

// Financial Tools
const MortgageCalculator = lazy(() => import('../components/calculators/finance/MortgageCalculator'));
const InvestmentCalculator = lazy(() => import('../components/calculators/finance/InvestmentCalculator'));
const LoanCalculator = lazy(() => import('../components/calculators/finance/LoanCalculator'));
const AutoLoanCalculator = lazy(() => import('../components/calculators/finance/AutoLoanCalculator'));
const CreditCardPayoffCalculator = lazy(() => import('../components/calculators/finance/CreditCardPayoffCalculator'));
const DebtConsolidationCalculator = lazy(() => import('../components/calculators/finance/DebtConsolidationCalculator'));
const BudgetCalculator = lazy(() => import('../components/calculators/finance/BudgetCalculator'));
const RetirementCalculator = lazy(() => import('../components/calculators/finance/RetirementCalculator'));
const CompoundInterestCalculator = lazy(() => import('../components/calculators/finance/CompoundInterestCalculator'));
const InflationCalculator = lazy(() => import('../components/calculators/finance/InflationCalculator'));
const PortfolioDiversificationCalculator = lazy(() => import('../components/calculators/finance/PortfolioDiversificationCalculator'));
const SalaryCalculator = lazy(() => import('../components/calculators/finance/SalaryCalculator'));
const IncomeTaxCalculator = lazy(() => import('../components/calculators/finance/IncomeTaxCalculator'));
const SalesTaxCalculator = lazy(() => import('../components/calculators/finance/SalesTaxCalculator'));
const TakeHomePayCalculator = lazy(() => import('../components/calculators/finance/TakeHomePayCalculator'));

// Health & Wellness
const BMICalculator = lazy(() => import('../components/calculators/health/BMICalculator'));
const DueDateCalculator = lazy(() => import('../components/calculators/health/DueDateCalculator'));
const OvulationCalculator = lazy(() => import('../components/calculators/health/OvulationCalculator'));
const ConceptionCalculator = lazy(() => import('../components/calculators/health/ConceptionCalculator'));
const CaloriesCalculator = lazy(() => import('../components/calculators/health/CaloriesCalculator'));
const MacroCalculator = lazy(() => import('../components/calculators/health/MacroCalculator'));
const ProteinCalculator = lazy(() => import('../components/calculators/health/ProteinCalculator'));
const TDEECalculator = lazy(() => import('../components/calculators/health/TDEECalculator'));
const SleepCalculator = lazy(() => import('../components/calculators/health/SleepCalculator'));
const WaterIntakeCalculator = lazy(() => import('../components/calculators/health/WaterIntakeCalculator'));

// Math & Education
const GraphingCalculator = lazy(() => import('../components/calculators/education/GraphingCalculator'));
const GeometryCalculator = lazy(() => import('../components/calculators/education/GeometryCalculator'));
const GPACalculator = lazy(() => import('../components/calculators/education/GPACalculator'));
const GradeCalculator = lazy(() => import('../components/calculators/education/GradeCalculator'));
const StudyTimeOptimizer = lazy(() => import('../components/calculators/education/StudyTimeOptimizer'));
const AcademicProgressTracker = lazy(() => import('../components/calculators/education/AcademicProgressTracker'));
const TriangleCalculator = lazy(() => import('../components/calculators/education/TriangleCalculator'));
const RandomNumberGenerator = lazy(() => import('../components/calculators/education/RandomNumberGenerator'));
const ProbabilityCalculator = lazy(() => import('../components/calculators/education/ProbabilityCalculator'));
const StatisticalSignificanceCalculator = lazy(() => import('../components/calculators/education/StatisticalSignificanceCalculator'));
const ScientificCalculator = lazy(() => import('../components/calculators/education/ScientificCalculator'));
const MatrixCalculator = lazy(() => import('../components/calculators/education/MatrixCalculator'));

// Lifestyle Tools
const AgeCalculator = lazy(() => import('../components/calculators/lifestyle/AgeCalculator'));
const DateCalculator = lazy(() => import('../components/calculators/lifestyle/DateCalculator'));
const TimeBetweenDatesCalculator = lazy(() => import('../components/calculators/lifestyle/TimeBetweenDatesCalculator'));
const LifeExpectancyCalculator = lazy(() => import('../components/calculators/lifestyle/LifeExpectancyCalculator'));
const CompatibilityCalculator = lazy(() => import('../components/calculators/lifestyle/CompatibilityCalculator'));
const LuckyNumberGenerator = lazy(() => import('../components/calculators/lifestyle/LuckyNumberGenerator'));
const WhichCharacterCalculator = lazy(() => import('../components/calculators/lifestyle/WhichCharacterCalculator'));
const PsychologicalCalculator = lazy(() => import('../components/calculators/lifestyle/PsychologicalCalculator'));
const TravelBudgetCalculator = lazy(() => import('../components/calculators/lifestyle/TravelBudgetCalculator'));
const GiftBudgetCalculator = lazy(() => import('../components/calculators/lifestyle/GiftBudgetCalculator'));
const PetFoodCalculator = lazy(() => import('../components/calculators/lifestyle/PetFoodCalculator'));

export const calculatorComponents = {
  // Professional Tools
  'ai-detector': AIDetectorCalculator,
  'hours': HoursCalculator,
  'productivity': ProductivityCalculator,
  'business-loan': BusinessLoanCalculator,
  'sba-loan': SBALoanCalculator,
  'equipment-loan': EquipmentLoanCalculator,
  'paint': PaintCalculator,
  'tile': TileCalculator,
  'roi': ROICalculator,
  'break-even': BreakEvenCalculator,
  'freelance-rate': FreelanceRateCalculator,
  'employee-cost': EmployeeCostCalculator,
  'conversion-rate': ConversionRateCalculator,
  'customer-lifetime-value': CustomerLifetimeValueCalculator,
  
  // Financial Tools
  'mortgage': MortgageCalculator,
  'investment': InvestmentCalculator,
  'loan': LoanCalculator,
  'auto-loan': AutoLoanCalculator,
  'credit-card-payoff': CreditCardPayoffCalculator,
  'debt-consolidation': DebtConsolidationCalculator,
  'budget': BudgetCalculator,
  'retirement': RetirementCalculator,
  'compound-interest': CompoundInterestCalculator,
  'inflation': InflationCalculator,
  'portfolio': PortfolioDiversificationCalculator,
  'salary': SalaryCalculator,
  'income-tax': IncomeTaxCalculator,
  'sales-tax': SalesTaxCalculator,
  'take-home-pay': TakeHomePayCalculator,

  // Health & Wellness
  'bmi': BMICalculator,
  'due-date': DueDateCalculator,
  'ovulation': OvulationCalculator,
  'conception': ConceptionCalculator,
  'calories': CaloriesCalculator,
  'macro': MacroCalculator,
  'protein': ProteinCalculator,
  'tdee': TDEECalculator,
  'sleep': SleepCalculator,
  'water-intake': WaterIntakeCalculator,

  // Math & Education
  'graphing': GraphingCalculator,
  'geometry': GeometryCalculator,
  'gpa': GPACalculator,
  'grade': GradeCalculator,
  'study-time': StudyTimeOptimizer,
  'academic-progress': AcademicProgressTracker,
  'triangle': TriangleCalculator,
  'random-number': RandomNumberGenerator,
  'probability': ProbabilityCalculator,
  'statistical-significance': StatisticalSignificanceCalculator,
  'scientific': ScientificCalculator,
  'matrix': MatrixCalculator,

  // Lifestyle Tools
  'age': AgeCalculator,
  'date': DateCalculator,
  'time-between': TimeBetweenDatesCalculator,
  'life-expectancy': LifeExpectancyCalculator,
  'compatibility': CompatibilityCalculator,
  'lucky-number': LuckyNumberGenerator,
  'character-quiz': WhichCharacterCalculator,
  'psychological': PsychologicalCalculator,
  'travel-budget': TravelBudgetCalculator,
  'gift-budget': GiftBudgetCalculator,
  'pet-food': PetFoodCalculator,
};

export const getCalculatorComponent = (id: string) => {
  return calculatorComponents[id as keyof typeof calculatorComponents];
};

export const updateCalculatorCategories = (categories: CalculatorCategory[]) => {
  return categories.map(category => ({
    ...category,
    calculators: category.calculators
      .filter(calc => !!getCalculatorComponent(calc.id))
      .map(calc => ({
        ...calc,
        component: getCalculatorComponent(calc.id)
      }))
  }));
};
